import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/configuracoes')({
  component: lazyRouteComponent(
    () => import('@/features/configuracoes/components/configuracoes-layout'),
    'ConfiguracoesLayout'
  ),
})
